"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  components: {},
  data: function data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted: function mounted() {},
  created: function created() {},
  methods: {
    resolveSource: function resolveSource(source) {
      if (window.LOWCODE.source) {
        return this.$lowcode.execute(source);
      } else {
        return this.$store.getters.getPageObject(source);
      }
    }
  }
};
exports["default"] = _default;